export const safelist = [
  'js-focus-visible',
  'sr-only',
  'notification-transition--slide-from-top-left-enter-to',
  'notification-transition--slide-from-top-left-leave',
  'notification-transition--slide-from-top-left-leave-to',
  'notification-transition--slide-from-top-center-enter',
  'notification-transition--slide-from-top-center-enter-to',
  'notification-transition--slide-from-top-center-leave',
  'notification-transition--slide-from-top-center-leave-to',
  'notification-transition--slide-from-top-right-enter',
  'notification-transition--slide-from-top-right-enter-to',
  'notification-transition--slide-from-top-right-leave',
  'notification-transition--slide-from-top-right-leave-to',
  'notification-transition--slide-from-bottom-left-enter',
  'notification-transition--slide-from-bottom-left-enter-to',
  'notification-transition--slide-from-bottom-left-leave',
  'notification-transition--slide-from-bottom-left-leave-to',
  'notification-transition--slide-from-bottom-center-enter',
  'notification-transition--slide-from-bottom-center-enter-to',
  'notification-transition--slide-from-bottom-center-leave',
  'notification-transition--slide-from-bottom-center-leave-to',
  'notification-transition--slide-from-bottom-right-enter',
  'notification-transition--slide-from-bottom-right-enter-to',
  'notification-transition--slide-from-bottom-right-leave',
  'notification-transition--slide-from-bottom-right-leave-to',
  'overlay-transition--fade-enter',
  'overlay-transition--fade-enter-to',
  'overlay-transition--fade-leave',
  'overlay-transition--fade-leave-to',
  'overlay-transition--fade-enter-active',
  'overlay-transition--fade-leave-active',
  'overlay-transition--zoom-enter',
  'overlay-transition--zoom-enter-to',
  'overlay-transition--zoom-leave',
  'overlay-transition--zoom-leave-to',
  'overlay-transition--zoom-enter-active',
  'overlay-transition--zoom-leave-active',
  'overlay-transition--slide-from-left-enter',
  'overlay-transition--slide-from-left-enter-to',
  'overlay-transition--slide-from-left-leave',
  'overlay-transition--slide-from-left-leave-to',
  'overlay-transition--slide-from-left-enter-active',
  'overlay-transition--slide-from-left-leave-active',
  'overlay-transition--slide-from-right-enter',
  'overlay-transition--slide-from-right-enter-to',
  'overlay-transition--slide-from-right-leave',
  'overlay-transition--slide-from-right-leave-to',
  'overlay-transition--slide-from-right-enter-active',
  'overlay-transition--slide-from-right-leave-active',
  'overlay-transition--slide-from-top-enter',
  'overlay-transition--slide-from-top-enter-to',
  'overlay-transition--slide-from-top-leave',
  'overlay-transition--slide-from-top-leave-to',
  'overlay-transition--slide-from-top-enter-active',
  'overlay-transition--slide-from-top-leave-active',
  'overlay-transition--slide-from-bottom-enter',
  'overlay-transition--slide-from-bottom-enter-to',
  'overlay-transition--slide-from-bottom-leave',
  'overlay-transition--slide-from-bottom-leave-to',
  'overlay-transition--slide-from-bottom-enter-active',
  'overlay-transition--slide-from-bottom-leave-active',
  'overlay-transition--scale-enter',
  'overlay-transition--scale-enter-to',
  'overlay-transition--scale-leave',
  'overlay-transition--scale-leave-to',
  'overlay-transition--scale-enter-active',
  'overlay-transition--scale-leave-active',
  'drawer--vertical-xs',
  'drawer--horizontal-xs',
  'drawer--vertical-sm',
  'drawer--horizontal-sm',
  'drawer--vertical-md',
  'drawer--horizontal-md',
  'drawer--vertical-lg',
  'drawer--horizontal-lg',
  'drawer--vertical-xl',
  'drawer--horizontal-xl',
  'drawer--vertical-full',
  'drawer--horizontal-full',
  'modal--xs',
  'modal--sm',
  'modal--md',
  'modal--lg',
  'modal--xl',
  'modal--full',
  'ember-power-select-trigger',
  'ember-power-select-trigger--active',
  'ember-power-select-placeholder',
  'ember-power-select-status-icon',
  'ember-power-select-dropdown',
  'ember-power-select-options',
  'ember-power-select-option',
  'ember-power-select-clear-btn',
  'ember-power-select-search',
  'ember-power-select-search-input',
  'ember-power-select-search-input--active',
  'ember-power-select-group',
  'ember-power-select-group-name',
  'ember-power-select-trigger-multiple-input',
  'ember-power-select-trigger-multiple-input--active',
  'ember-power-select-multiple-options',
  'ember-power-select-multiple-option',
  'ember-power-select-multiple-remove-btn',
  'ember-power-select-trigger-sm',
  'ember-power-select-trigger-lg'
];
